import { render, staticRenderFns } from "./CollectionMenu.vue?vue&type=template&id=658bf9cc&"
import script from "./CollectionMenu.vue?vue&type=script&lang=ts&"
export * from "./CollectionMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports